const dateFormat = require('dateformat')
window.dateFormat = dateFormat



//////////////////
// WEBPACK FOOTER
// ./plugins/dateformat.js
// module id = BVOm
// module chunks = 1